/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BaseCensusDto } from '../api-models';
// @ts-ignore
import { BaseResponseOfIEnumerableOfGetUnitsResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfIEnumerableOfViewUnitDto } from '../api-models';
// @ts-ignore
import { BaseResponseOfString } from '../api-models';
// @ts-ignore
import { BaseResponseOfViewUnitDto } from '../api-models';
// @ts-ignore
import { ProblemDetails } from '../api-models';
/**
 * UnitApi - axios parameter creator
 * @export
 */
export const UnitApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieves a list of units based on the optional facility ID.
         * @param {number} [facilityId] Optional facility ID to filter the units. If not provided, all units will be retrieved.
         * @param {boolean} [includeCensus] Flag to include the unit censuses in the response. Default is false.
         * @param {boolean} [filteredByOpeningTemplates] Optional filter to indicate whether results should include only units if opening template exists, by default filter is false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unitGet: async (facilityId?: number, includeCensus?: boolean, filteredByOpeningTemplates?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Unit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (includeCensus !== undefined) {
                localVarQueryParameter['includeCensus'] = includeCensus;
            }

            if (filteredByOpeningTemplates !== undefined) {
                localVarQueryParameter['filteredByOpeningTemplates'] = filteredByOpeningTemplates;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unitIdFacilityIdGet: async (id: number, facilityId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unitIdFacilityIdGet', 'id', id)
            // verify required parameter 'facilityId' is not null or undefined
            assertParamExists('unitIdFacilityIdGet', 'facilityId', facilityId)
            const localVarPath = `/Unit/{id}/{facilityId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"facilityId"}}`, encodeURIComponent(String(facilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing unit with the provided data (its base census). Needs the role  permission Edit Census, the one the census page takes (SPD-62, SPD-6083): without it the  answer is 403 with the reason.
         * @param {number} id The ID of the unit to update.
         * @param {BaseCensusDto} [baseCensusDto] The data to update the unit with.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unitIdPut: async (id: number, baseCensusDto?: BaseCensusDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unitIdPut', 'id', id)
            const localVarPath = `/Unit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseCensusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Use Floor APIs from LaborLevelController instead
         * @param {number} [employeeId] 
         * @param {number} [positionId] 
         * @param {number} [shiftTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unitUnitsByShiftTypeAndPositionGet: async (employeeId?: number, positionId?: number, shiftTypeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Unit/units-by-shift-type-and-position`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (shiftTypeId !== undefined) {
                localVarQueryParameter['shiftTypeId'] = shiftTypeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnitApi - functional programming interface
 * @export
 */
export const UnitApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UnitApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieves a list of units based on the optional facility ID.
         * @param {number} [facilityId] Optional facility ID to filter the units. If not provided, all units will be retrieved.
         * @param {boolean} [includeCensus] Flag to include the unit censuses in the response. Default is false.
         * @param {boolean} [filteredByOpeningTemplates] Optional filter to indicate whether results should include only units if opening template exists, by default filter is false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unitGet(facilityId?: number, includeCensus?: boolean, filteredByOpeningTemplates?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfViewUnitDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unitGet(facilityId, includeCensus, filteredByOpeningTemplates, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} facilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unitIdFacilityIdGet(id: number, facilityId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewUnitDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unitIdFacilityIdGet(id, facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates an existing unit with the provided data (its base census). Needs the role  permission Edit Census, the one the census page takes (SPD-62, SPD-6083): without it the  answer is 403 with the reason.
         * @param {number} id The ID of the unit to update.
         * @param {BaseCensusDto} [baseCensusDto] The data to update the unit with.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unitIdPut(id: number, baseCensusDto?: BaseCensusDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unitIdPut(id, baseCensusDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Use Floor APIs from LaborLevelController instead
         * @param {number} [employeeId] 
         * @param {number} [positionId] 
         * @param {number} [shiftTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unitUnitsByShiftTypeAndPositionGet(employeeId?: number, positionId?: number, shiftTypeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfGetUnitsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unitUnitsByShiftTypeAndPositionGet(employeeId, positionId, shiftTypeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UnitApi - factory interface
 * @export
 */
export const UnitApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UnitApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieves a list of units based on the optional facility ID.
         * @param {UnitApiUnitGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unitGet(requestParameters: UnitApiUnitGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfViewUnitDto> {
            return localVarFp.unitGet(requestParameters.facilityId, requestParameters.includeCensus, requestParameters.filteredByOpeningTemplates, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UnitApiUnitIdFacilityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unitIdFacilityIdGet(requestParameters: UnitApiUnitIdFacilityIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewUnitDto> {
            return localVarFp.unitIdFacilityIdGet(requestParameters.id, requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing unit with the provided data (its base census). Needs the role  permission Edit Census, the one the census page takes (SPD-62, SPD-6083): without it the  answer is 403 with the reason.
         * @param {UnitApiUnitIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unitIdPut(requestParameters: UnitApiUnitIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfString> {
            return localVarFp.unitIdPut(requestParameters.id, requestParameters.baseCensusDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Use Floor APIs from LaborLevelController instead
         * @param {UnitApiUnitUnitsByShiftTypeAndPositionGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unitUnitsByShiftTypeAndPositionGet(requestParameters: UnitApiUnitUnitsByShiftTypeAndPositionGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfGetUnitsResponse> {
            return localVarFp.unitUnitsByShiftTypeAndPositionGet(requestParameters.employeeId, requestParameters.positionId, requestParameters.shiftTypeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for unitGet operation in UnitApi.
 * @export
 * @interface UnitApiUnitGetRequest
 */
export interface UnitApiUnitGetRequest {
    /**
     * Optional facility ID to filter the units. If not provided, all units will be retrieved.
     * @type {number}
     * @memberof UnitApiUnitGet
     */
    readonly facilityId?: number

    /**
     * Flag to include the unit censuses in the response. Default is false.
     * @type {boolean}
     * @memberof UnitApiUnitGet
     */
    readonly includeCensus?: boolean

    /**
     * Optional filter to indicate whether results should include only units if opening template exists, by default filter is false
     * @type {boolean}
     * @memberof UnitApiUnitGet
     */
    readonly filteredByOpeningTemplates?: boolean
}

/**
 * Request parameters for unitIdFacilityIdGet operation in UnitApi.
 * @export
 * @interface UnitApiUnitIdFacilityIdGetRequest
 */
export interface UnitApiUnitIdFacilityIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitApiUnitIdFacilityIdGet
     */
    readonly id: number

    /**
     * 
     * @type {number}
     * @memberof UnitApiUnitIdFacilityIdGet
     */
    readonly facilityId: number
}

/**
 * Request parameters for unitIdPut operation in UnitApi.
 * @export
 * @interface UnitApiUnitIdPutRequest
 */
export interface UnitApiUnitIdPutRequest {
    /**
     * The ID of the unit to update.
     * @type {number}
     * @memberof UnitApiUnitIdPut
     */
    readonly id: number

    /**
     * The data to update the unit with.
     * @type {BaseCensusDto}
     * @memberof UnitApiUnitIdPut
     */
    readonly baseCensusDto?: BaseCensusDto
}

/**
 * Request parameters for unitUnitsByShiftTypeAndPositionGet operation in UnitApi.
 * @export
 * @interface UnitApiUnitUnitsByShiftTypeAndPositionGetRequest
 */
export interface UnitApiUnitUnitsByShiftTypeAndPositionGetRequest {
    /**
     * 
     * @type {number}
     * @memberof UnitApiUnitUnitsByShiftTypeAndPositionGet
     */
    readonly employeeId?: number

    /**
     * 
     * @type {number}
     * @memberof UnitApiUnitUnitsByShiftTypeAndPositionGet
     */
    readonly positionId?: number

    /**
     * 
     * @type {number}
     * @memberof UnitApiUnitUnitsByShiftTypeAndPositionGet
     */
    readonly shiftTypeId?: number
}

/**
 * UnitApi - object-oriented interface
 * @export
 * @class UnitApi
 * @extends {BaseAPI}
 */
export class UnitApi extends BaseAPI {
    /**
     * 
     * @summary Retrieves a list of units based on the optional facility ID.
     * @param {UnitApiUnitGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitApi
     */
    public unitGet(requestParameters: UnitApiUnitGetRequest = {}, options?: AxiosRequestConfig) {
        return UnitApiFp(this.configuration).unitGet(requestParameters.facilityId, requestParameters.includeCensus, requestParameters.filteredByOpeningTemplates, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UnitApiUnitIdFacilityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitApi
     */
    public unitIdFacilityIdGet(requestParameters: UnitApiUnitIdFacilityIdGetRequest, options?: AxiosRequestConfig) {
        return UnitApiFp(this.configuration).unitIdFacilityIdGet(requestParameters.id, requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing unit with the provided data (its base census). Needs the role  permission Edit Census, the one the census page takes (SPD-62, SPD-6083): without it the  answer is 403 with the reason.
     * @param {UnitApiUnitIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitApi
     */
    public unitIdPut(requestParameters: UnitApiUnitIdPutRequest, options?: AxiosRequestConfig) {
        return UnitApiFp(this.configuration).unitIdPut(requestParameters.id, requestParameters.baseCensusDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Use Floor APIs from LaborLevelController instead
     * @param {UnitApiUnitUnitsByShiftTypeAndPositionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnitApi
     */
    public unitUnitsByShiftTypeAndPositionGet(requestParameters: UnitApiUnitUnitsByShiftTypeAndPositionGetRequest = {}, options?: AxiosRequestConfig) {
        return UnitApiFp(this.configuration).unitUnitsByShiftTypeAndPositionGet(requestParameters.employeeId, requestParameters.positionId, requestParameters.shiftTypeId, options).then((request) => request(this.axios, this.basePath));
    }
}
